import { Button, Collapse, Form, Input } from 'antd'
import { useSelector } from 'react-redux'
import { recoverPassword } from './store/store'
import { ErrorMessage } from './ErrorMessage'
import { SuccessMessage } from './SuccessMessage'

const { Panel } = Collapse

function PasswordRecovery() {
  const recovery = useSelector(state => state.recovery)
  const [form] = Form.useForm()

  const handleSubmit = (values) => {
    recoverPassword({ email: values.email })
    form.resetFields()
  }

  return (
    <Collapse ghost accordion className="password-recovery">
      <Panel header="Забыли пароль?" key="recovery">
        <SuccessMessage message={ recovery.sent && 'Инструкции по восстановлению отправлены на указанный e-mail' } />
        <ErrorMessage error={ recovery.error } />
        <Form
          form={form}
          name="password-recovery"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          onFinish={handleSubmit}
          autoComplete="off"
        >
          <Form.Item
            label="Эл. Почта"
            name="email"
            rules={[
              { type: 'email', message: 'The input is not valid E-mail!' },
              { required: true, message: 'Введите адрес Вашей электронной почты' }
            ]}
          >
            <Input autoComplete="email" placeholder="example@domain.com" />
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <Button type="primary" htmlType="submit" loading={recovery.isLoading}>
              Восстановить пароль
            </Button>
          </Form.Item>
        </Form>
      </Panel>
    </Collapse>
  )
}

export default PasswordRecovery
